import { NodeContextProvider } from '@/node-editor';
import { RenderChildren } from '@/node-editor/components';
import {
  getWidgetsByAreaList,
  getWidgetsByAreaMap,
  WIDGET_AREAS,
} from '@/widget-editor/utilities';
import {
  Box,
  FormControlLabel,
  ListItemIcon,
  MenuItem,
  Switch,
  Typography,
} from '@material-ui/core';
import React, { Fragment } from 'react';
import { RenderComponent } from '../component/render-component';
import { WidgetContext } from '../provider/widget-provider';

interface IAreaProps {
  area: typeof WIDGET_AREAS[number];
}

interface ActivateProps {
  value: boolean;
  activate: (isActive: boolean) => void;
}

const Activate = ({ activate, value = false }: ActivateProps) => {
  return (
    <FormControlLabel
      control={
        <Switch
          checked={value}
          onChange={() => {
            activate(!value);
          }}
          color="primary"
        />
      }
      label=""
    />
  );
};

export const WidgetArea = ({ area }: IAreaProps) => {
  return (
    <WidgetContext.Consumer>
      {({
        widgets,
        usingDefault,
        moderating,
        isModerator,
        setWidgetActive,
      }) => {
        // See that such an area exists in the DB
        const areaExist =
          widgets &&
          Object.values(widgets).find(
            (w) => w.type === 'widget-area' && w.content.areaName === area
          );
        if (!areaExist) {
          return null;
        }

        return (
          widgets && (
            <Fragment>
              {isModerator() && moderating ? (
                usingDefault ? (
                  <Box>
                    Can't edit default. Setup Widgets in manager to edit.
                  </Box>
                ) : (
                  getWidgetsByAreaList(area, widgets).map((widget) => (
                    <Box pb={1} key={widget.id}>
                      <Box display="flex" key={widget.id} alignItems="center">
                        <Box>
                          <Activate
                            value={widget.active}
                            activate={(isActive) =>
                              setWidgetActive(widget.id, isActive)
                            }
                          />
                        </Box>
                        <Box flexGrow={1}>
                          <Typography variant="inherit">
                            {widget.content.widgetName}
                          </Typography>
                        </Box>
                      </Box>

                      <React.Suspense fallback="">
                        <NodeContextProvider readOnly>
                          <RenderChildren>
                            {[{ ...widget, active: true }]}
                          </RenderChildren>
                        </NodeContextProvider>
                      </React.Suspense>
                    </Box>
                  ))
                )
              ) : (
                <RenderComponent
                  value={{ ...getWidgetsByAreaMap(area, widgets) }}
                />
              )}
            </Fragment>
          )
        );
      }}
    </WidgetContext.Consumer>
  );
};
